import { Typography } from "@circle-react-uikit/Typography";

import { t } from "@/i18n-js/instance";

import { BillingCurrency } from "../../RegularPlan/BillingCurrency";

export const PlanSelectorTitle = () => (
  <div className="border-primary flex items-center justify-between px-6 pb-5 pt-6">
    <Typography.LabelXl weight="semibold" color="text-dark">
      {t("pricing_plans.plan_settings.plan_selection.title")}
    </Typography.LabelXl>
    <BillingCurrency />
  </div>
);
